"use strict";
/**
 * @module Services.SessionLock
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var BEES = require("./../../serialisers/byte-encoded-enum-serialiser");
var serialiser_1 = require("./../../serialisers/serialiser");
var session_lock_options_1 = require("../../../features/session-lock-options");
var session_lock_acquisition_1 = require("./session-lock-acquisition");
/**
 * Serialiser for {@link SessionLockAcquisition}
 */
var SessionLockAcquisitionSerialiserClass = /** @class */ (function (_super) {
    __extends(SessionLockAcquisitionSerialiserClass, _super);
    function SessionLockAcquisitionSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link SessionLockAcquisition} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link SessionLockAcquisition} that was read
     */
    SessionLockAcquisitionSerialiserClass.prototype.read = function (bis) {
        var lockName = Codec.readString(bis);
        var sequence = Codec.readInt64(bis);
        var scope = BEES.read(bis, session_lock_options_1.SessionLockScope);
        return new session_lock_acquisition_1.SessionLockAcquisition(lockName, sequence, scope);
    };
    /**
     * Write a {@link SessionLockAcquisition} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link SessionLockAcquisition} to be written
     */
    SessionLockAcquisitionSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.lockName);
        Codec.writeInt64(bos, value.sequence);
        BEES.write(bos, value.scope);
    };
    return SessionLockAcquisitionSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.SessionLockAcquisitionSerialiserClass = SessionLockAcquisitionSerialiserClass;
/**
 * The {@link SessionLockAcquisitionSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.SessionLockAcquisitionSerialiser = new SessionLockAcquisitionSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/session-lock/session-lock-acquisition-serialiser.js
// module id = 1631
// module chunks = 1